import React, { useState } from 'react';
import './Equipment.css';

const Equipment = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [showAllCapabilityImages, setShowAllCapabilityImages] = useState(false);

  // Generate array of capability images
  const capabilityImages = Array.from({ length: 16 }, (_, index) => 
    `/images/nangLuc/Công bố năng lực Trung tâm thí nghiệm vật liệu và Khảo sát địa chất-images-${index}.jpg`
  );

  const displayedImages = showAllCapabilityImages ? capabilityImages : capabilityImages.slice(0, 3);

  const equipment = [
    // Thiết bị khảo sát và đo đạc
    {
      id: 1,
      name: "Máy toàn đạc điện tử",
      category: "khao-sat",
      description: "Thiết bị đo đạc chính xác cao cho công tác khảo sát địa hình",
      image: "may-toan-dac.jpg"
    },
    {
      id: 2,
      name: "Máy kinh vĩ",
      category: "khao-sat", 
      description: "Dụng cụ đo góc ngang và góc đứng trong trắc địa",
      image: "may-kinh-vi.jpg"
    },
    {
      id: 3,
      name: "Máy thủy bình",
      category: "khao-sat",
      description: "Thiết bị đo cao độ và độ dốc địa hình", 
      image: "may-thuy-binh.jpg"
    },
    {
      id: 4,
      name: "Máy định vị toàn cầu GPS",
      category: "khao-sat",
      description: "Hệ thống định vị vệ tinh cho công tác đo đạc hiện đại",
      image: "may-gps.jpg"
    },
    {
      id: 5,
      name: "Chân máy",
      category: "phu-kien",
      description: "Chân đỡ cho các thiết bị đo đạc, đảm bảo ổn định",
      image: "chan-may.jpg"
    },

    // Thiết bị nén và thí nghiệm
    {
      id: 6,
      name: "Máy kéo nén vạn năng",
      category: "nen-cat",
      description: "Máy thí nghiệm cường độ kéo và nén vật liệu",
      image: "may-keo-nen.jpg"
    },
    {
      id: 7,
      name: "Máy khoan khảo sát địa chất XJ-100",
      category: "dia-chat",
      description: "Máy khoan chuyên dụng cho khảo sát địa chất và lấy mẫu đất",
      image: "may-khoan-xj100.jpg"
    },
    {
      id: 8,
      name: "Máy trộn xi măng",
      category: "xi-mang",
      description: "Máy trộn mẫu xi măng cho thí nghiệm",
      image: "may-tron-xi-mang.jpg"
    },
    {
      id: 9,
      name: "Máy nén vữa",
      category: "nen-cat",
      description: "Thiết bị thí nghiệm cường độ nén vữa xi măng",
      image: "may-nen-vua.jpg"
    },
    {
      id: 10,
      name: "Máy cắt đất (Máy cắt phẳng)",
      category: "nen-cat",
      description: "Thiết bị cắt mẫu đất theo kích thước chuẩn",
      image: "may-cat-dat.jpg"
    },
    {
      id: 11,
      name: "Bộ sàng tiêu chuẩn",
      category: "sang-phan-loai",
      description: "Bộ sàng phân tích thành phần hạt đất, cát",
      image: "bo-sang.jpg"
    },
    {
      id: 12,
      name: "Máy dằn tạo mẫu xi măng",
      category: "xi-mang",
      description: "Thiết bị tạo mẫu thử xi măng theo tiêu chuẩn",
      image: "may-dan-xi-mang.jpg"
    },
    {
      id: 13,
      name: "Máy nén đất tam niên",
      category: "nen-cat",
      description: "Thiết bị thí nghiệm cắt trực tiếp đất",
      image: "may-nen-dat.jpg"
    },
    {
      id: 14,
      name: "Cân thủy tĩnh TD (độ phân giải 0,1g)",
      category: "can-do",
      description: "Cân chính xác cao cho thí nghiệm vật liệu",
      image: "can-thuy-tinh.jpg"
    },
    {
      id: 15,
      name: "Cân điện tử JM-B (độ phân giải 0,01g)",
      category: "can-do",
      description: "Cân điện tử độ chính xác cao",
      image: "can-dien-tu.jpg"
    },
    {
      id: 16,
      name: "Tủ sấy 300°C",
      category: "say-nhiet",
      description: "Tủ sấy mẫu vật liệu ở nhiệt độ cao",
      image: "tu-say.jpg"
    },
    {
      id: 17,
      name: "Bộ cần Benkenman",
      category: "thi-nghiem",
      description: "Thiết bị đo độ võng của mặt đường",
      image: "bo-can-benkenman.jpg"
    },
    {
      id: 18,
      name: "Bình định mức",
      category: "can-do",
      description: "Dụng cụ đo thể tích chính xác",
      image: "binh-dinh-muc.jpg"
    },
    {
      id: 19,
      name: "Bộ dao vòng",
      category: "thi-nghiem",
      description: "Dụng cụ lấy mẫu đất nguyên dạng cho thí nghiệm",
      image: "bo-dao-vong.jpg"
    },
    {
      id: 20,
      name: "Cối đầm tiêu chuẩn",
      category: "thi-nghiem",
      description: "Thiết bị đầm nén mẫu đất theo tiêu chuẩn",
      image: "coi-dam.jpg"
    },
    {
      id: 21,
      name: "Phễu rót cát",
      category: "sang-phan-loai",
      description: "Dụng cụ rót cát trong thí nghiệm",
      image: "pheu-rot-cat.jpg"
    },
    {
      id: 22,
      name: "Bàn dằn vữa xi măng",
      category: "xi-mang",
      description: "Bàn rung tạo mẫu vữa xi măng",
      image: "ban-dan-vua.jpg"
    },
    {
      id: 23,
      name: "Bình hút ẩm",
      category: "say-nhiet",
      description: "Thiết bị hút ẩm bảo quản mẫu",
      image: "binh-hut-am.jpg"
    },
    {
      id: 24,
      name: "Kim Vika xi măng",
      category: "xi-mang",
      description: "Dụng cụ đo thời gian đông kết xi măng",
      image: "kim-vika.jpg"
    }
  ];

  const categories = [
    { id: 'all', name: 'Tất cả thiết bị', icon: '🔧' },
    { id: 'khao-sat', name: 'Khảo sát đo đạc', icon: '📐' },
    { id: 'dia-chat', name: 'Địa chất', icon: '🗻' },
    { id: 'thi-nghiem', name: 'Thí nghiệm đất', icon: '🧪' },
    { id: 'xi-mang', name: 'Xi măng & vữa', icon: '🏗️' },
    { id: 'nen-cat', name: 'Nén & cắt', icon: '⚡' },
    { id: 'can-do', name: 'Cân & đo lường', icon: '⚖️' },
    { id: 'say-nhiet', name: 'Sấy & gia nhiệt', icon: '🔥' },
    { id: 'sang-phan-loai', name: 'Sàng & phân loại', icon: '🔍' },
    { id: 'phu-kien', name: 'Phụ kiện', icon: '🔩' }
  ];

  const filteredEquipment = selectedCategory === 'all' 
    ? equipment 
    : equipment.filter(item => item.category === selectedCategory);

  return (
    <div className="equipment-page">
      <div className="container">
        {/* Page Header */}
        <section className="page-header">
          <h1>Thiết bị & Trung tâm Thí nghiệm</h1>
          <p>Trung tâm thí nghiệm vật liệu và khảo sát địa chất LAS-XD27.004 với 102 chỉ tiêu thí nghiệm chuyên ngành</p>
        </section>

        {/* Laboratory Info */}
        <section className="laboratory-info">
          <div className="lab-header">
            <h2>🏢 Trung tâm Thí nghiệm Vật liệu và Khảo sát Địa chất</h2>
            <div className="lab-details">
              <div className="lab-detail-item">
                <strong>Mã số phòng thí nghiệm:</strong> LAS-XD 27.004
              </div>
              <div className="lab-detail-item">
                <strong>Giấy chứng nhận:</strong> Số 3335/GCN-SXD ngày 05/07/2024
              </div>
              <div className="lab-detail-item">
                <strong>Cơ quan cấp:</strong> Sở Xây dựng Hải Phòng
              </div>
              <div className="lab-detail-item">
                <strong>Địa chỉ:</strong> Lô 258 - dự án An Đồng – Phường An Hải – Thành phố Hải Phòng
              </div>
              <div className="lab-detail-item">
                <strong>Hiệu lực:</strong> 5 năm (đến năm 2029)
              </div>
            </div>
            
            {/* Download Section */}
            <div className="lab-download">
              <h3>📄 Công bố năng lực thí nghiệm chuyên ngành xây dựng</h3>
              {/* Capability Images Gallery */}
              <div className="equipment-capability-images-section">
                
                <div className="equipment-capability-images-grid">
                  {displayedImages.map((imageSrc, index) => (
                    <div key={index} className="equipment-capability-image-item">
                      <img 
                        src={imageSrc} 
                        alt={`Năng lực thí nghiệm ${index + 1}`}
                        loading="lazy"
                      />
                    </div>
                  ))}
                </div>
                
                <div className="equipment-capability-images-controls">
                  <button 
                    className="btn btn-outline"
                    onClick={() => setShowAllCapabilityImages(!showAllCapabilityImages)}
                  >
                    {showAllCapabilityImages ? (
                      <>
                        <span>📤</span> Thu gọn
                      </>
                    ) : (
                      <>
                        <span>📥</span> Hiển thị thêm ({capabilityImages.length - 3} hình)
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Test Categories */}
        <section className="test-categories">
          <h2>📋 Phạm vi Thí nghiệm (102 chỉ tiêu)</h2>
          <div className="test-categories-grid">
            <div className="test-category-card">
              <div className="category-header">
                <span className="category-icon">🏗️</span>
                <h3>I. Xi măng (3 chỉ tiêu)</h3>
              </div>
              <ul>
                <li>Xác định độ mịn, khối lượng riêng của xi măng</li>
                <li>Xác định giới hạn bền uốn và nén</li>
                <li>Xác định độ dẻo tiêu chuẩn, thời gian đông kết và tính ổn định thể tích</li>
              </ul>
            </div>

            <div className="test-category-card">
              <div className="category-header">
                <span className="category-icon">🪨</span>
                <h3>II. Cốt liệu cho bê tông và vữa (12 chỉ tiêu)</h3>
              </div>
              <ul>
                <li>Xác định thành phần cơ hạt</li>
                <li>Xác định khối lượng riêng, khối lượng thể tích và độ hút nước</li>
                <li>Xác định độ ẩm, độ hút nước</li>
                <li>Xác định hàm lượng bùn, bụi, sét trong cốt liệu</li>
                <li>Xác định độ hao mòn khi va đập trong máy Los Angeles</li>
                <li>Và 8 chỉ tiêu khác...</li>
              </ul>
            </div>

            <div className="test-category-card">
              <div className="category-header">
                <span className="category-icon">🧱</span>
                <h3>III. Hỗn hợp bê tông và bê tông nặng (10 chỉ tiêu)</h3>
              </div>
              <ul>
                <li>Xác định độ sụt của hỗn hợp bê tông</li>
                <li>Xác định cường độ chịu nén</li>
                <li>Xác định cường độ chịu kéo khi uốn</li>
                <li>Xác định độ chống thấm của bê tông</li>
                <li>Xác định cường độ bê tông trên mẫu lấy từ kết cấu</li>
                <li>Và 8 chỉ tiêu khác...</li>
              </ul>
            </div>

            <div className="test-category-card">
              <div className="category-header">
                <span className="category-icon">🏠</span>
                <h3>IV. Vữa xây dựng (4 chỉ tiêu)</h3>
              </div>
              <ul>
                <li>Xác định độ lưu động của vữa tươi</li>
                <li>Xác định khối lượng thể tích của vữa tươi</li>
                <li>Xác định cường độ uốn và nén của vữa đã đông rắn</li>
                <li>Xác định độ hút nước của vữa đã đông rắn</li>
              </ul>
            </div>

            <div className="test-category-card">
              <div className="category-header">
                <span className="category-icon">🧱</span>
                <h3>V. Gạch và đá ốp lát (8 chỉ tiêu)</h3>
              </div>
              <ul>
                <li>Gạch xây đất sét nung: Kiểm tra kích thước, khuyết tật</li>
                <li>Gạch bê tông và gạch bê tông tự chèn</li>
                <li>Gạch lát xi măng và gạch lát Granite</li>
                <li>Gạch gốm ốp lát</li>
                <li>Đá ốp lát tự nhiên và nhân tạo</li>
              </ul>
            </div>

            <div className="test-category-card">
              <div className="category-header">
                <span className="category-icon">⚙️</span>
                <h3>VI. Kim loại và mối hàn (9 chỉ tiêu)</h3>
              </div>
              <ul>
                <li>Thử kéo và thử uốn</li>
                <li>Kiểm tra chất lượng mối hàn ống</li>
                <li>Thử phá hủy mối hàn vật liệu kim loại</li>
                <li>Thử kéo bu lông neo</li>
                <li>Kiểm tra không phá hủy mối hàn – Phương pháp siêu âm</li>
                <li>Và 4 chỉ tiêu khác...</li>
              </ul>
            </div>

            <div className="test-category-card">
              <div className="category-header">
                <span className="category-icon">🌍</span>
                <h3>VII. Cơ lý đất trong phòng (17 chỉ tiêu)</h3>
              </div>
              <ul>
                <li>Xác định khối lượng riêng (tỷ trọng)</li>
                <li>Xác định độ ẩm và độ hút ẩm</li>
                <li>Xác định giới hạn dẻo, giới hạn chảy</li>
                <li>Xác định thành phần cơ hạt</li>
                <li>Thí nghiệm sức chịu tải của đất (CBR)</li>
                <li>Và 12 chỉ tiêu khác...</li>
              </ul>
            </div>

            <div className="test-category-card">
              <div className="category-header">
                <span className="category-icon">🏗️</span>
                <h3>VIII-XII. Các chỉ tiêu khác (65 chỉ tiêu)</h3>
              </div>
              <ul>
                <li>Cơ lý đá xây dựng trong phòng (2 chỉ tiêu)</li>
                <li>Thí nghiệm tại hiện trường (9 chỉ tiêu)</li>
                <li>Nhựa bitum (8 chỉ tiêu)</li>
                <li>Bê tông nhựa (20 chỉ tiêu)</li>
                <li>Phân tích hóa nước cho xây dựng (5 chỉ tiêu)</li>
                <li>Phụ gia cho bê tông và vữa (1 chỉ tiêu)</li>
                <li>Cơ lý đất trong phòng (16 chỉ tiêu)</li>
                <li>Gạch các loại (8 chỉ tiêu)</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Equipment Stats */}
        <section className="equipment-stats">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">102</div>
              <div className="stat-label">Chỉ tiêu thí nghiệm</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">12</div>
              <div className="stat-label">Nhóm thí nghiệm</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">5</div>
              <div className="stat-label">Năm hiệu lực GCN</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">2029</div>
              <div className="stat-label">Hiệu lực đến năm</div>
            </div>
          </div>
        </section>

        {/* Category Filter */}
        <section className="category-filter">
          <h2>Danh mục thiết bị</h2>
          <div className="category-buttons">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                <span className="category-icon">{category.icon}</span>
                {category.name}
              </button>
            ))}
          </div>
        </section>

        {/* Equipment Grid */}
        <section className="equipment-grid">
          {filteredEquipment.map(item => (
            <div key={item.id} className="equipment-card">
              <div className="equipment-image" onClick={() => setSelectedImage(item)}>
                <img 
                  src={`/images/equipment/${item.image}`} 
                  alt={item.name}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="placeholder-image" style={{display: 'none'}}>
                  <span>📷 {item.name}</span>
                </div>
                <div className="image-overlay">
                  <span>🔍 Xem chi tiết</span>
                </div>
              </div>
              
              <div className="equipment-content">
                <h3>{item.name}</h3>
                <p className="equipment-description">{item.description}</p>
              </div>
            </div>
          ))}
        </section>

        {/* Equipment Capabilities */}
        <section className="equipment-capabilities">
          <h2>Năng lực thiết bị</h2>
          <div className="capabilities-grid">
            <div className="capability-item">
              <div className="capability-icon">🎯</div>
              <h4>Độ chính xác cao</h4>
              <p>Các thiết bị đo đạc đạt độ chính xác milimét, đảm bảo kết quả tin cậy</p>
            </div>
            <div className="capability-item">
              <div className="capability-icon">🔬</div>
              <h4>Thí nghiệm đa dạng</h4>
              <p>Đầy đủ thiết bị cho các loại thí nghiệm đất, xi măng, vật liệu xây dựng</p>
            </div>
            <div className="capability-item">
              <div className="capability-icon">⚡</div>
              <h4>Hiệu suất cao</h4>
              <p>Thiết bị hiện đại giúp tăng tốc độ và chất lượng công việc</p>
            </div>
            <div className="capability-item">
              <div className="capability-icon">🛡️</div>
              <h4>Bảo trì định kỳ</h4>
              <p>Hệ thống bảo trì và hiệu chuẩn định kỳ đảm bảo hoạt động ổn định</p>
            </div>
          </div>
        </section>

        {/* Maintenance Info */}
        <section className="maintenance-info">
          <div className="maintenance-content">
            <h2>Bảo trì & Hiệu chuẩn</h2>
            <p>Tất cả thiết bị được bảo trì định kỳ và hiệu chuẩn theo tiêu chuẩn quốc tế</p>
            <div className="maintenance-features">
              <div className="feature-item">
                <span className="feature-icon">🔧</span>
                <span>Bảo trì định kỳ hàng tháng</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">📊</span>
                <span>Hiệu chuẩn theo tiêu chuẩn</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">📋</span>
                <span>Ghi chép đầy đủ lịch sử</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✅</span>
                <span>Chứng nhận chất lượng</span>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedImage(null)}>
              ✕
            </button>
            <div className="modal-image">
              <img 
                src={`/images/equipment/${selectedImage.image}`} 
                alt={selectedImage.name}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="modal-placeholder" style={{display: 'none'}}>
                <span>📷 {selectedImage.name}</span>
              </div>
            </div>
            <div className="modal-info">
              <h3>{selectedImage.name}</h3>
              <p>{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Equipment;